import { SITE_DETAILS_MOBILE_BOTTOM_CLEARANCE } from './layout';

/** Bottom padding for mobile floating nav — apply on the single scroll root only */
export const mobileBottomNavScrollPadding = {
  paddingBottom: `calc(${SITE_DETAILS_MOBILE_BOTTOM_CLEARANCE}px + env(safe-area-inset-bottom, 0px))`,
  boxSizing: 'border-box',
};
